import { RoundedElementKeyOption, RoundedPluginOptionsValues } from './types';
import { RoundedElement } from './component/RoundedElement';
import { ColorDefinition } from '../highlight/types';
import { colorsV2 } from '../../../colors-v2';

export const ELEMENT_ROUNDED = 'roundedElement';
export const HOTKEY = 'mod+l';

export const DEFAULT_ROUNDED_COLORS = {
  white100: {
    color: colorsV2.white100,
    key: 'white100',
  },
  gray20: {
    color: colorsV2.gray20,
    key: 'gray20',
  },
  primary100: {
    color: colorsV2.primary100,
    key: 'primary100',
  },
  yellow40: {
    color: colorsV2.yellow100,
    key: 'yellow40',
  },
  purple100: {
    color: colorsV2.purple100,
    key: 'purple100',
  },
  green40: {
    color: colorsV2.green100,
    key: 'green40',
  },
  blue100: {
    color: colorsV2.blue100,
    key: 'blue100',
  },
  red40: {
    color: colorsV2.red100,
    key: 'red40',
  },
  blue40: {
    color: colorsV2.blue100,
    key: 'blue40',
  },
  purple40: {
    color: colorsV2.purple100,
    key: 'purple40',
  },
  pink40: {
    color: colorsV2.pink100,
    key: 'pink40',
  },
};

export const DEFAULT_ROUNDED_COLORS_LIST: ColorDefinition[] = [
  DEFAULT_ROUNDED_COLORS.gray20,
  DEFAULT_ROUNDED_COLORS.primary100,
  DEFAULT_ROUNDED_COLORS.yellow40,
  DEFAULT_ROUNDED_COLORS.purple100,
  DEFAULT_ROUNDED_COLORS.green40,
  DEFAULT_ROUNDED_COLORS.blue100,
];

export const DEFAULT_ROUNDED: Record<
  RoundedElementKeyOption,
  Required<RoundedPluginOptionsValues>
> = {
  roundedElement: {
    component: RoundedElement,
    type: ELEMENT_ROUNDED,
    rootProps: {
      className: 'slate-rounded-element',
    },
    hotkey: HOTKEY,
    defaultType: '',
    colors: DEFAULT_ROUNDED_COLORS_LIST,
  },
};
